import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const IDLE_TIMEOUT = 90000; // 1.5 minutes in milliseconds
const EVENTS = ['click', 'touchstart', 'keydown'];

const useIdleRedirect = () => {
  const { pathname } = useLocation();
  const timer = useRef(null);

  useEffect(() => {
    if (pathname === '/') return;

    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        window.location.href = '/';
      }, IDLE_TIMEOUT);
    };

    reset();
    EVENTS.forEach(e => window.addEventListener(e, reset));

    return () => {
      clearTimeout(timer.current);
      EVENTS.forEach(e => window.removeEventListener(e, reset));
    };
  }, [pathname]);
};

export default useIdleRedirect;
